import { useMutation } from '@tanstack/react-query';
import { authAPI } from '@/services/auth.service';
import toast from 'react-hot-toast';
import { ForgotPasswordPayload, ForgotPasswordResponse } from '@/types';
import { handleAnyError } from '@/lib/utils';


export const useForgotPassword = () => {
    return useMutation<ForgotPasswordResponse, Error, ForgotPasswordPayload>({
        mutationFn: (payload) => authAPI.forgotPassword(payload),

        onMutate: () => {
            toast.loading('Sending password reset link...', { id: 'forgotPassword' });
        },

        onSuccess: (data) => {
            toast.success(
                data?.message || 'Password reset link sent successfully!',
                { id: 'forgotPassword' }
            );
        },

        onError: handleAnyError,

        onSettled: () => {
            toast.dismiss('forgotPassword');
        },
    });
};
